import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

import { ColorSettings } from './ColorSettings'
import { Footer } from './Footer'
import { Header } from './Header'
import { Templates } from './Templates'
import { Languages, Variable } from '../../../../common/models'
import { getAllEmailTemplateVariables } from '../../../../core/services/email-templates'
import { getSettingsLanguages } from '../../../../core/services/festival-settings'
import { useAppSelector } from '../../../../store'
import { MessageBox } from '../../messages/MessageBox'
import { Header as PageHeaderComponent, PageTitle } from '@/components'
import { Card, Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui'
type Tabs = 'Header' | 'Footer' | 'Colors' | 'Template'

export const EmailTemplatesPage: React.FC = () => {
  const [selectedTemplate, setSelectedTemplate] = useState<string>('')
  const [allLanguages, setAllLanguages] = useState<Languages[]>([])
  const [key, setKey] = useState<Tabs>('Header')
  const { festivalName } = useParams()
  const { festivals: storeFestivals } = useAppSelector((s) => s.app)
  const festivalFullName = storeFestivals.find(
    (f) => f.platformName === festivalName,
  )?.name
  const [variables, setVariables] = useState<Variable[]>([])

  const [isError, setIsError] = useState<boolean>(false)
  const [showMessageBox, setShowMessageBox] = useState<boolean>(false)
  const [message, setMessage] = useState<string>('')

  useEffect(() => {
    // prettier-ignore
    (async () => {
      try {
        const allLanguagesResponse = await getSettingsLanguages()
        setAllLanguages(allLanguagesResponse.data)
      } catch (e) {
        if (e instanceof Error) {
          setIsError(true)
          setShowMessageBox(true)
          setMessage(e.message)
        } else {
          console.error(e)
        }
      }
    })()
  }, [])

  useEffect(() => {
    // prettier-ignore
    (async () => {
      try {
        if (selectedTemplate !== '') {
          const resp2 = await getAllEmailTemplateVariables(selectedTemplate)
          if (resp2.status === 200) {
            setVariables(resp2.data)
          }
        }
      } catch (e) {
        if (e instanceof Error) {
          setIsError(true)
          setShowMessageBox(true)
          setMessage(e.message)
        } else {
          console.error(e)
        }
      }
    })()
  }, [selectedTemplate])

  return (
    <>
      <PageHeaderComponent pageTitle="Email Templates" />

      <Card className="p-4 max-h-[calc(100vh-150px)] overflow-y-auto">
        <PageTitle title="Email Templates" />
        <Tabs defaultValue="Header" className="w-full">
          <TabsList className="grid w-full grid-cols-4">
            <TabsTrigger value="Header">Header</TabsTrigger>
            <TabsTrigger value="Footer">Footer</TabsTrigger>
            <TabsTrigger value="Templates">Templates</TabsTrigger>
            <TabsTrigger value="Color">Color</TabsTrigger>
          </TabsList>
          <TabsContent value="Header">
            <Header />
          </TabsContent>
          <TabsContent value="Footer">
            <Footer allLanguages={allLanguages} variables={variables} />
          </TabsContent>
          <TabsContent value="Templates">
            <Templates
              setSelectedTemplate={setSelectedTemplate}
              selectedTemplate={selectedTemplate}
              allLanguages={allLanguages}
              variables={variables}
            />
          </TabsContent>
          <TabsContent value="Color">
            <ColorSettings />
          </TabsContent>
        </Tabs>
      </Card>
      <MessageBox
        message={message}
        setShowMessageBox={setShowMessageBox}
        showMessageBox={showMessageBox}
        isError={isError}
      />
    </>
  )
}
